import React from 'react';

import { isGoGameEnv } from 'App/constants';

import {
  Actions as UIActions,
  Action,
  ViewCompactIcon,
  ViewColumnIcon,
  FormatColorFillOutlinedIcon,
  FileDownloadIcon,
  Stack,
  Divider,
} from '@gogame/components';
import {
  FullScreenToggler,
  AutosizeColumns,
  DefaultSizeColumns,
} from '@gogame/data-grid';

import { VIEW_AS_COHORT } from './constants';

const Actions = ({
  onExport,
  onExportGoogleDrive,
  onExportWhenReady,
  onOpenSubscriptionsForm,

  onToggleCohortView,

  onShowColorScales,
  onHideColorScales,

  onCustomizeColumns,
  colorScaled,
  disabledExport,
  disabledCustomizeColumns,
  accentExport,
  isCohortMode,
  openArea,
}) => {
  return (
    <Stack direction={'row'} spacing={1} alignItems={'center'}>
      <UIActions activeId={openArea}>
        <Action
          icon={<ViewCompactIcon />}
          label={'View as cohorts'}
          badge={isCohortMode}
          onClick={onToggleCohortView}
          id={VIEW_AS_COHORT}
        />
        <Action
          icon={<ViewColumnIcon />}
          label={'Customize columns'}
          onClick={onCustomizeColumns}
          disabled={disabledCustomizeColumns}
        />
        {colorScaled ? (
          <Action
            icon={<FormatColorFillOutlinedIcon />}
            onClick={onHideColorScales}
            label={'Hide color scales'}
            componentProps={{ crossed: true }}
          />
        ) : (
          <Action
            icon={<FormatColorFillOutlinedIcon />}
            onClick={onShowColorScales}
            label={'Show color scales'}
          />
        )}

        <Action
          icon={<FileDownloadIcon />}
          disabled={disabledExport}
          accent={accentExport}
          tooltip={
            disabledExport
              ? 'Unable to export a dimension with > 500k records'
              : ''
          }
        >
          <Action label={'Export'} onClick={onExport} />
          {isGoGameEnv && (
            <Action
              label={'Export to Google Sheets'}
              onClick={onExportGoogleDrive}
            />
          )}
          {isGoGameEnv && (
            <Action label={'Send to email'} onClick={onExportWhenReady} />
          )}
          {isGoGameEnv && (
            <Action label={'Subscribe'} onClick={onOpenSubscriptionsForm} />
          )}
        </Action>
      </UIActions>
      <Divider orientation={'vertical'} flexItem />
      <UIActions>
        {!isCohortMode ? <Action component={AutosizeColumns} /> : null}
        {!isCohortMode ? <Action component={DefaultSizeColumns} /> : null}
        <Action component={FullScreenToggler} />
      </UIActions>
    </Stack>
  );
};

export default Actions;
